module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('infinite-calendar', {
    attrs: {
      "current-date": _vm.currentDate,
      "today": _vm.today,
      "end-date": _vm.endDate,
      "start-date": _vm.startDate,
      "mode": "rangeTo",
      "callback": _vm.setTime
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bfc4254","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/infinite-calendar.vue
// module id = 548
// module chunks = 0